/* eslint-disable no-useless-escape */
// Hannah Neal: no-useless-escape has been disabled for regular expressions in the form below.
import React, { useState } from "react";
import { FormGroup, Form, Input } from "reactstrap";
import PropTypes from "prop-types";
import {
  PromotionDropdownButtonClosed,
  PromotionDropdownButtonOpen
} from "./promotionDropdownButton";

const PromotionForm = ({ setPromoString, calculateCart }) => {
  /*
   *  When the showPromoForm = true, icon is (-)
   *  When showPromoForm = false, icon is (+)
   *  This is for the dropdown toggle button
   */
  const [showPromoForm, setShowPromoForm] = useState(false);

  const toggleDropdown = () => {
    setShowPromoForm(!showPromoForm);
  };

  const [formPromoString, setFormPromoString] = useState("");

  // Hannah Neal: This sets up an array and functions for multiple promos later as well as ensuring that the promos are pushed into an array (the correct format) before setting any state. If multiple promos are implemented, this can be concatenated upon and the same functions below can be used.
  const temporaryArray = [];

  const handleSubmit = p => {
    setPromoString(p);
    temporaryArray.push(p);
    calculateCart({ promosToApply: temporaryArray });
    setFormPromoString("");
  };

  const handleEnter = e => {
    e.preventDefault();
    if (formPromoString !== "") {
      setPromoString(formPromoString);
      temporaryArray.push(formPromoString);
      if (
        temporaryArray !== null ||
        ((temporaryArray !== undefined) !== temporaryArray) !== ""
      ) {
        calculateCart({ promosToApply: temporaryArray });
      }
      setFormPromoString("");
    }
  };

  return (
    <>
      <tr
        role="row"
        className="promotionFormDropdown"
        id="promotionFormDropdown"
      >
        <td role="cell" className="promotionDropdownButtonContainer">
          {showPromoForm === false ? (
            <PromotionDropdownButtonClosed
              showPromoForm={showPromoForm}
              setShowPromoForm={setShowPromoForm}
              toggleDropdown={toggleDropdown}
            />
          ) : (
            <PromotionDropdownButtonOpen
              showPromoForm={showPromoForm}
              setShowPromoForm={setShowPromoForm}
              toggleDropdown={toggleDropdown}
            />
          )}
        </td>
      </tr>
      {showPromoForm === false ? null : (
        <tr
          role="row"
          className="promotionFormContainer"
          id="promotionFormContainer"
        >
          <td
            role="cell"
            className="promotionFormTableCell"
            id="promotionFormTableCell"
          >
            <FormGroup>
              <Form
                className="promotionForm"
                id="promotionForm"
                label="promotion form"
              >
                <Input
                  className="promotionFormInput"
                  id="promotionFormInput"
                  aria-label="Enter Promotion Code"
                  onChange={e => {
                    // Hannah Neal: This captures the input value only if white spaces, commas, and brackets are not included. This is a double-check to ensure that calculateCart (a POST method which accepts an array of comma-separated strings as the promotion values) does not receive a corrupt request.
                    const str = e.target.value
                      .replace(/[ ,.\[\]]+/g, "")
                      .toUpperCase();
                    setFormPromoString(str);
                  }}
                  // Hannah Neal: Using onKeyDown here instead of onSubmit enables finer control of the form and the Valid/Invalid Feedback than using onSubmit at the Form level for this particular use-case.
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      handleEnter(e);
                    }
                  }}
                  value={formPromoString}
                />
              </Form>
              <small className="promotion-helper-text">
                Only one promotion code per order.
              </small>
            </FormGroup>
          </td>
          <td
            role="cell"
            className="promotionForm__applyButtonContainer"
            id="promotionFormApplyButtonContainer"
          >
            <FormGroup>
              <button
                className={`promotionForm__applyButton
                  ${
                    formPromoString === "" ||
                    formPromoString === null ||
                    formPromoString === undefined ||
                    formPromoString.match(/[ ,.\[\]]+/g, "")
                      ? "promotionForm__applyButton--disabled"
                      : "promotionForm__applyButton"
                  }`}
                id="promotionFormApplyButton"
                type="button"
                onClick={e => {
                  e.preventDefault();
                  handleSubmit(formPromoString);
                }}
                disabled={
                  formPromoString === "" ||
                  formPromoString === null ||
                  formPromoString === undefined ||
                  formPromoString.match(/[ ,.\[\]]+/g, "")
                }
              >
                Apply
              </button>
            </FormGroup>
          </td>
        </tr>
      )}
    </>
  );
};

PromotionForm.propTypes = {
  setPromoString: PropTypes.func,
  calculateCart: PropTypes.func
};

PromotionForm.defaultProps = {
  setPromoString: undefined,
  calculateCart: undefined
};

export default PromotionForm;
